// @ts-nocheck
import stringValueToNumberValue from "@store/Framework/Common/Utilities/stringValueToNumberValue";
import { remToPx } from "@toolkit/Framework/Common/Utilities/unitHelper";

type ValueType = "px" | "rem";

export default (value: string, valueType: ValueType = "px") => {
    if (valueType === "rem") {
        const remValue = stringValueToNumberValue(value);
        const pxValue = remToPx(remValue);

        return stringValueToNumberValue(pxValue);
    }

    return stringValueToNumberValue(value);
};
